export default __webpack_public_path__ + "static/media/community.dc5dea79.png";